export default {
    full_name       : 'Full Name',
    dob             : 'DOB (mm/dd/yyyy)',
    gender          : 'Gender',
    height          : 'Height',
    weight          : 'Weight (in Kg’s)',
    shoe_size       : 'Shoe size',
    package_id      : 'Package',
    skier_type      : 'Skier type',
    ski_board_length: 'Board length',
    snowboard_type  : 'Snowboard Stance',
    discount        : 'Discount',
    prepay_tax      : 'Sales Tax',
    package_price   : 'Package Price'
}

